const regex = {
  "waist": /^[1-9][0-9]{0,2}$/,
  "weight": /^[1-9][0-9]{0,2}$/,
  "height": /^[1-9][0-9]{0,2}$/,
}
export default regex